/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import ActivityHeader from '../../components/ActivityHeader/ActivityHeader'
import AbortPractice from '../../components/AbortPractice/AbortPractice'
import ModalLemonadeOnboarding from '../../../../../modules/modals/ModalLemonadeOnboarding/ModalLemonadeOnboarding'
import translate from '../../../../../i18n/translate'
import IssueReport from '../../components/IssueReport/IssueReport'
import Toast from '../../components/Toast/Toast'
import ActivityLoading from '../../components/ActivityLoading/ActivityLoading'
import ActivityBlueberryComponent from '../../../../../_practice-components/pages/ActivityBlueberryComponent/ActivityBlueberryComponent'
import { ACTIVITY_TYPES } from '../../../../../_practice-components/constants/ActivityConstants'
import { usePracticeView } from './usePracticeView'
import './practiceView.scss'
import { Analysis } from '../../../../../services/analysisService'
import useSound from '../../../../../modules/views/MetaberryView/hooks/useSound'
import { getCurrentLangString } from '../../../../../i18n/initI18n'
import InformationPopup from '../../../../../modules/atoms/InformationPopup/InformationPopup'
import DIFFICULT_ACTIVITY_COINS_REWARD from '../../../../../config/constants/difficultActivity'
import ModalSimple from '../../../../../modules/modals/ModalSimple/ModalSimple'
import { getCourseMultiplicationSymbol } from '../../../../../services/courseInfoService'
import PracticeButton from '../../atoms/PracticeButton/PracticeButton'
import { ReactComponent as SvgIssue } from '../../../assets/icons/flag.svg'

const PracticeView = ({
  practiceBaseData,
  setPracticeBaseData,
  practiceProgressData,
  setPracticeProgressData,
  practiceState,
  setPracticeState,
  messageToReactNative,
  isIphone,
  setResetActivityGamification
}) => {
  const { renderSoundFXController, playSoundEffect } = useSound()

  const isDevMode = useSelector((state) => state?.configuration?.isDevMode)

  const practiceViewRef = useRef(null)

  const {
    isBeforeFirstExercise,
    getPracticeStartExercise,
    experienceTotal,
    experienceNormal,
    experienceExtra,
    setShowAbortPracticePopup,
    currentExercise,
    previousSeedId,
    numberExercisesCorrect,
    numberExercisesIncorrect,
    setExperienceTotal,
    practiceStartedDate,
    activityShowed,
    onActivityEvent,
    showLemonadeOnboarding,
    setShowLemonadeOnboarding,
    hasPreviowsOnboardinPopup,
    setHasPreviowsOnboardinPopup,
    hasPreviowsExtraEffortPopup,
    setHasPreviowsExtraEffortPopup,
    questionData,
    getTemplateKey,
    showAbortPracticePopup,
    showIssueReportPopup,
    setShowIssueReportPopup,
    sendIssuesReport,
    showToast,
    setShowToast,
    resetPracticeStates,
    hasCheckExerciseAPiResponded,
    getStimulusAudio,
    getTextAudio,
    widthClass,
    setShowDifficultActivityPopup,
    showDifficultActivityPopup,
    isDifficultActivity,
    setIsDifficultActivity,
    showPenAndPaperBadget,
    difficultActivityAnswered,
    pathAssetsSchool,
    checkAnswerThroughApi,
    checkActivityError,
    setCheckActivityError,
    checkActivityRetryValues,
    CHECK_ACTIVITY_ERRORS,
    isMobileSize
  } = usePracticeView({
    practiceBaseData,
    setPracticeBaseData,
    practiceProgressData,
    setPracticeProgressData,
    setPracticeState,
    messageToReactNative,
    playSoundEffect,
    practiceViewRef,
    setResetActivityGamification
  })

  const initialPathSchool = useSelector(
    (state) => state.configuration.pathSchool
  )

  const [customMultiplicationSymbol, setCustomMultiplicationSymbol] =
    useState(undefined)

  const [isStandalone, setIsStandalone] = useState(false)

  useEffect(() => {
    // Detectar modo standalone/fullscreen
    const isInStandaloneMode =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    setIsStandalone(isInStandaloneMode)
  }, [])

  const getIphoneSpacingClass = () => {
    if (!isIphone) return ''

    // Usar visualViewport para una detección más precisa
    const viewportHeight = window.visualViewport?.height || window.innerHeight
    const windowHeight = window.innerHeight
    const hasBottomToolbar = Math.abs(viewportHeight - windowHeight) > 20 // umbral de 20px para evitar falsos positivos

    return hasBottomToolbar
      ? ' practice-view_iphone'
      : ' practice-view_iphone-no-space'
  }

  const getSpacingClass = () => {
    if (!widthClass.includes('phone-size')) return ''
    if (!isIphone) return ' practice-view_no-space'
    return getIphoneSpacingClass()
  }

  useEffect(() => {
    setCustomMultiplicationSymbol(getCourseMultiplicationSymbol())

    Analysis.sendSegmentPageEvent(
      Analysis.SEGMENT_PAGE_CATEGORIES.Game,
      Analysis.SEGMENT_EVENTS['Activity Page']
    )
  }, [])

  useEffect(() => {
    if (practiceState === 1) {
      resetPracticeStates()
      setExperienceTotal(parseInt(practiceBaseData?.lessonChallengeExp))
      getPracticeStartExercise()
    }
  }, [practiceState])

  return isBeforeFirstExercise ? (
    <ActivityLoading
      title={translate('app_practice_loading_title')}
      message={translate('app_practice_loading_message')}
    />
  ) : (
    <div
      className={
        'practice-view' +
        widthClass +
        getSpacingClass() +
        (!practiceBaseData.isFromApp ? ' practice-view_web' : '')
      }
      ref={practiceViewRef}
    >
      {renderSoundFXController()}
      {practiceBaseData?.statusBarHeight ? (
        <div
          className="margin-for-status-bar"
          style={{
            width: '1px',
            height: practiceBaseData.statusBarHeight + 'px'
          }}
        ></div>
      ) : null}
      <ActivityHeader
        barMax={experienceTotal}
        barCurrent={experienceNormal + experienceExtra}
        messageToReactNative={messageToReactNative}
        isPractice={true}
        setShowAbortPracticePopup={setShowAbortPracticePopup}
        currentExercise={currentExercise}
        previousSeedId={previousSeedId}
        numberExercisesCorrect={numberExercisesCorrect}
        numberExercisesIncorrect={numberExercisesIncorrect}
        practiceStartedDate={practiceStartedDate}
        setShowIssueReportPopup={setShowIssueReportPopup}
        isFromApp={practiceBaseData.isFromApp}
        isDifficultActivity={isDifficultActivity}
        showPenAndPaperBadget={showPenAndPaperBadget}
        difficultActivityAnswered={difficultActivityAnswered}
        practiceBaseData={practiceBaseData}
        pathSchool={initialPathSchool}
        practiceProgressData={practiceProgressData}
      />

      {/* Para "WebView"            -> 'regular-practice':     ejercicios normales y 'scaffolding-practice':     scaffold
          Para "App (react native)" -> 'regular-practice-app': ejercicios normales y 'scaffolding-practice-app': scaffold
       */}
      {activityShowed && (
        <div className="practice-view__exercise regular-practice-app">
          <ActivityBlueberryComponent
            activityType={ACTIVITY_TYPES.PRACTICE}
            activity={activityShowed}
            onActivityEvent={onActivityEvent}
            uiLanguage={getCurrentLangString()}
            isDemoMode={isDevMode}
            activityInformation={{
              exerciseGuid: currentExercise?.guid,
              nodeDepartment: currentExercise?.node_department,
              nodeName: currentExercise?.node_name,
              phase: currentExercise?.phase,
              learningObjectiveName: currentExercise?.learning_objective_name
            }}
            hasCheckExerciseAPiResponded={hasCheckExerciseAPiResponded}
            requiresAudioAssistance={practiceBaseData.requiresAudioAssistance}
            exerciseLanguage={practiceBaseData.language}
            hasPreviowsPopups={
              hasPreviowsOnboardinPopup || hasPreviowsExtraEffortPopup
            }
            getStimulusAudio={getStimulusAudio}
            getTextAudio={getTextAudio}
            mathRenderEngine="katex"
            multiplicationSymbol={customMultiplicationSymbol}
            pathAssetsSchool={pathAssetsSchool}
          />

          {/* Mostrar como se realiza la actividad (GIF) */}
          {questionData && showLemonadeOnboarding && (
            <ModalLemonadeOnboarding
              open={showLemonadeOnboarding}
              handleClose={(event) => {
                // Ignora cualquier clic que venga desde el interior del modal
                if (event.target !== event.currentTarget) {
                  return
                }
                setShowLemonadeOnboarding(false)
                setHasPreviowsOnboardinPopup(false)
              }}
              handleCloseBtn={() => {
                setShowLemonadeOnboarding(false)
                setHasPreviowsOnboardinPopup(false)
              }}
              template={
                questionData?.metadata?.name
                  ? getTemplateKey(
                      questionData.metadata.name,
                      questionData.data
                    )
                  : ''
              }
            />
          )}
        </div>
      )}

      {showAbortPracticePopup && (
        <AbortPractice
          experience={experienceNormal + experienceExtra}
          setShowAbortPracticePopup={setShowAbortPracticePopup}
          messageToReactNative={messageToReactNative}
          practiceStartedDate={practiceStartedDate}
          currentExercise={currentExercise}
          previousSeedId={previousSeedId}
          numberExercisesCorrect={numberExercisesCorrect}
          numberExercisesIncorrect={numberExercisesIncorrect}
          isFromApp={practiceBaseData.isFromApp}
        />
      )}

      {showDifficultActivityPopup && !showLemonadeOnboarding && (
        <InformationPopup
          message={translate('difficult_activity_popup_message')}
          coins={DIFFICULT_ACTIVITY_COINS_REWARD}
          closeAction={() => {
            setIsDifficultActivity(true)
            setShowDifficultActivityPopup(false)
            setHasPreviowsExtraEffortPopup(false)
          }}
          buttonText={translate('difficult_activity_popup_button')}
          buttonAction={() => {
            setIsDifficultActivity(true)
            setShowDifficultActivityPopup(false)
            setHasPreviowsExtraEffortPopup(false)
          }}
          audioFile={'activityExtraRewardPopup_' + getCurrentLangString()}
        />
      )}

      {showIssueReportPopup && (
        <IssueReport
          setShowIssueReportPopup={setShowIssueReportPopup}
          sendIssuesReport={sendIssuesReport}
          isFromApp={practiceBaseData.isFromApp}
          practiceBaseData={practiceBaseData}
        />
      )}

      {showToast && (
        <Toast closeToast={() => setShowToast(null)} data={showToast} />
      )}

      <ModalSimple
        showModal={checkActivityError}
        onCloseComplete={() => {
          checkAnswerThroughApi(
            checkActivityRetryValues.isUserCorrect,
            checkActivityRetryValues.userResponse,
            checkActivityRetryValues.isScaffold
          )
        }}
        onCloseStart={() => {
          setCheckActivityError(CHECK_ACTIVITY_ERRORS.noError)
          window.history.back()
        }}
        title={translate('popup_error_activity_check_answer_title')}
        message={translate(
          checkActivityError === CHECK_ACTIVITY_ERRORS.timeout
            ? 'popup_error_activity_check_answer_message_try_again'
            : checkActivityError === CHECK_ACTIVITY_ERRORS.timeoutRetries
            ? 'popup_error_activity_check_answer_message_timeout_retries'
            : 'popup_error_activity_check_answer_message_any'
        )}
        buttonText={
          checkActivityError === CHECK_ACTIVITY_ERRORS.timeout
            ? translate('popup_error_activity_check_answer_button_retry')
            : ''
        }
        withCloseButton={true}
        customClass={'modal-practice-network-error'}
      ></ModalSimple>
    </div>
  )
}

export default PracticeView
